/**
 * Document Processing Helper Functions
 *
 * Lightweight utilities that don't require importing heavy dependencies.
 * These are safe to import in components without triggering vendor-docprocessing bundle.
 */

/**
 * Validate if a file is a valid DOCX file
 */
export function isValidDocxFile(file: File): boolean {
  return file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
    file.name.endsWith('.docx');
}

/**
 * Validate if a file is a valid Pages file
 */
export function isValidPagesFile(file: File): boolean {
  return file.type === 'application/vnd.apple.pages' ||
    file.type === 'application/x-iwork-pages-sffpages' ||
    file.name.endsWith('.pages');
}

/**
 * Convert file size to human-readable format
 */
export function getReadableFileSize(bytes: number): string {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
}
